import React, { useState } from 'react';
import { Card, Container, Table } from 'react-bootstrap';
import { ApiDeviceResponse, Device } from '../../interfaces';
import DeviceDetailsOffCanvas from './DeviceDetailsOffCanvas';
import { useTranslation } from 'react-i18next';
import DateField from '../common/DateField';

const TableComponent: React.FC<ApiDeviceResponse> = ({ result }) => {
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [selectedEan, setSelectedEan] = useState<string | null | undefined>(null);
  const { t } = useTranslation();

  const handleRowClick = (device: Device) => {
    if (selectedEan !== device.ean) {
      setSelectedEan(device.ean);
      setShowOffCanvas(true);
    }
  };

  const handleClose = () => {
    setShowOffCanvas(false);
    setSelectedEan(null);
  };

  return (
    <>
      <Container className="mt-5">
        <Card className="shadow">
          <Card.Header className="bg-secondary text-white text-center">
            <Card.Title className="fs-2">{t("devices.overview")}</Card.Title>
          </Card.Header>
          <Table responsive striped bordered hover className="text-center align-middle">
            <thead>
              <tr>
                <th>ID</th>
                <th>EAN</th>
                <th>{t("devices.table.lastApicall")}</th>
              </tr>
            </thead>
            <tbody>
              {result.map(device => (
                <tr className='clickable-row' key={device.id} onClick={() => handleRowClick(device)}>
                  <td>{device.id}</td>
                  <td>{device.ean}</td>
                  <td><DateField date={device.lastApiCall} /></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      </Container>

      {showOffCanvas && selectedEan && (
        <DeviceDetailsOffCanvas
          show={showOffCanvas}
          handleClose={handleClose}
          ean={selectedEan}
        />
      )}
    </>
  );
};

export default TableComponent;
